var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"row"},[_c('NoRecords',{attrs:{"main_icon":"fa fa-wrench","value":"false","title":"Ez a menüpont fejlesztés alatt áll","subtitle":"Térjen vissza később"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"page-header"},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Fejlesztés alatt"),_c('small')])
}]

export { render, staticRenderFns }